import { currentFirebaseProjectId } from "./firebase";

const encodeFirestoreConsolePath = (path: string): string => path.replace(/\//g, "~2F");

export const getFirestoreConsoleUrlForPath = (path: string): string => {
  const trimmed = path.trim();
  if (!trimmed) {
    return "";
  }
  const normalized = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  const encoded = encodeFirestoreConsolePath(normalized);
  return `https://console.firebase.google.com/u/0/project/${currentFirebaseProjectId}/firestore/databases/-default-/data/${encoded}`;
};
